<div class="item cn-up-down">
	<i class="icon audio-mes">
		<tag-ico></tag-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Тегирование</div>
</div>
<div *ngIf="node != null && node.next != null" schema-node [node]="node.next"></div>